import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { type notificationEvent } from 'Pages/CareNetworkManagement/CareNetworkDetail/ChildHistoryDisplay'
import { FormatDateTimeValue } from 'core/Utilities'

interface DashboardNotificationCardProps {
  event: notificationEvent
  onOpen: (event: notificationEvent) => void
}

export function DashboardNotificationCard (props: DashboardNotificationCardProps): JSX.Element {
  const { event } = props
  const [open, setOpen] = useState(false)

  const toggle = (): void => {
    if (!open) {
      props.onOpen(event)
    }
    setOpen(!open)
  }

  return (
    <Box data-testid={`dashboard-notification-${event.id}`} sx={{ backgroundColor: '#ECEDEF', borderRadius: '10px', px: '20px', py: '16px' }}>
      <Box onClick={toggle} sx={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
        <EmailIcon sx={{ color: '#222024' }} />
        <Box sx={{ flex: '1 0 0', minWidth: 0 }}>
          <Typography sx={{ color: '#222024', fontSize: '14px', fontWeight: 600 }} data-testid='notificationMessage'>
            {event.message}
          </Typography>
          <Typography sx={{ color: '#514F53', fontSize: '12px' }} data-testid='notificationReceived'>
            Received {FormatDateTimeValue(new Date(event.eventDate))}
          </Typography>
        </Box>
        {open ? <RemoveIcon sx={{ color: '#222024' }} /> : <AddIcon sx={{ color: '#222024' }} />}
      </Box>
      {open && (
        <Box sx={{ mt: '12px', pl: '36px', fontSize: '14px', color: '#222024' }} data-testid='notificationDetails'>
          {event.childName !== '' && <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{event.childName}</Typography>}
          <div dangerouslySetInnerHTML={{ __html: event.description }} />
        </Box>
      )}
    </Box>
  )
}
